// 📄 hooks/useCasosPruebaProgress.ts
// Progreso de casos de prueba APROBADOS por canal, para el badge secundario
// de CommerceHome.tsx (ver FeatureCard) — complementa a
// useAllChannelsProgress.ts (que mide config, no pruebas). Agrupa por
// `canalId` (mismo id que usa CasoPruebaFormModal para Commerce: CANALES_
// COMMERCE_ITEMS con el prefijo "integracion/" recortado — 'oc',
// 'expedicion', etc.), NO por el id del catálogo de checklist técnico
// (esos son namespaces distintos, ver commerceChecklistCatalog.ts).
import { useEffect, useState } from 'react';
import { getCasosPrueba } from '../services/casoPruebaService.ts';

export interface CasoPruebaProgress {
  aprobados: number;
  total: number;
}

export function useCasosPruebaProgress(projectId: string) {
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState<Record<string, CasoPruebaProgress>>({});

  useEffect(() => {
    if (!projectId) {
      setLoading(false);
      return;
    }
    let cancelado = false;
    setLoading(true);
    getCasosPrueba(projectId)
      .then((casos) => {
        if (cancelado) return;
        const result: Record<string, CasoPruebaProgress> = {};
        casos.forEach((c) => {
          if (!c.canalId) return;
          if (!result[c.canalId]) result[c.canalId] = { aprobados: 0, total: 0 };
          result[c.canalId].total += 1;
          if (c.estado === 'Aprobado') result[c.canalId].aprobados += 1;
        });
        setProgress(result);
      })
      .catch((err) => console.error('Error cargando progreso de casos de prueba:', err))
      .finally(() => { if (!cancelado) setLoading(false); });
    return () => { cancelado = true; };
  }, [projectId]);

  return { loading, progress };
}
